'use strict';

/**
 *
 * @name: AdminAccessRun
 *
 */

function AdminAccessRun($rootScope, $localStorage, $state) {

  'ngInject';

  $rootScope.$on('$stateChangeStart', function(event, next) {

    if (next.data && next.data.requiresAdminAccess) {

      if (!($localStorage.NownessAdmin &&
          $localStorage.NownessAdmin.user &&
          $localStorage.NownessAdmin.user.isAdmin)) {

        event.preventDefault();
        $state.go('main.adminAccess.login');
      }
    }
  });

}

export default AdminAccessRun;



// WEBPACK FOOTER //
// ./app/pages/admin-access/admin-access.run.js